import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'raviger';
import { Card, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseChimney } from '@fortawesome/free-solid-svg-icons';
import Header from '../components/Header';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';

function Shelter({ incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({shelters: [],  isFetching: false});
  //const [selectedShelter, setSelectedShelter] = useState(null);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchShelters = async () => {
      setData({shelters: [], isFetching: true});
      // Fetch Shelter data.
      await axios.get('/shelter/api/shelter/?incident=' + incident + '&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData({shelters: response.data, isFetching: false});
        }
      })
      .catch(error => {
        if (!unmounted) {
          setData({shelters: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    fetchShelters();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [incident]);

  return (
    <>
    <Header>Shelter</Header>
    <Row className="ms-0">
      {data.shelters.map(shelter => (
        <Col key={shelter.id} xs={6} className="ps-0" style={{minWidth:"400px", marginBottom:"12px"}}>
          <Link href={"/" + organization + "/" + incident + "/shelter/" + shelter.id} className="shelter-link ps-0 pe-0" style={{textDecoration:"none", color:"white"}}>
            <Card style={{height:"100px", whiteSpace:"nowrap"}}>
              <div className="row no-gutters" style={{height:"100px", textTransform:"capitalize", marginRight:"-12px", marginLeft:"10px", cursor:"default"}}>
                <Row className="p-0 w-100 border rounded hover-div shelter-hover-div" style={{flexWrap:"nowrap", cursor:"pointer"}}>
                  <div className="border-end" style={{width:"100px"}}>
                    <FontAwesomeIcon icon={faHouseChimney} size="6x" className="shelter-icon" style={{marginTop:"4px", paddingRight:"10px", marginLeft:"-8px", "--fa-primary-color":'#5d4a35ff'}} transform="shrink-1" />
                  </div>
                  <Col style={{marginLeft:"0px", marginRight:"-2px", paddingRight:"0px", paddingLeft:"0px", marginTop:"0px"}}>
                    <div className="border" style={{paddingTop:"5px", paddingBottom:"7px", paddingLeft:"10px", marginLeft:"-1px", marginTop: "-1px", fontSize:"18px", width:"100%", borderTopRightRadius:".25rem", backgroundColor:"#615e5e"}}>
                      {shelter.name} - {shelter.animal_count || "0"} Animal{shelter.animal_count === 1 ? "" :"s"}
                    </div>
                    <div style={{marginTop:"6px", marginLeft:"10px"}}>
                      {shelter.full_address}
                    </div>
                    <div style={{marginLeft:"10px"}}>
                      {shelter.display_phone}
                    </div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Link>
        </Col>
      ))}
    </Row>
    </>
  )
}

export default Shelter
